import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const usePainterNotificationsPanelStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.common.white,
    maxWidth: 480,
    margin: '0 auto'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2, 1.625),
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  menuBtn: {
    padding: 0,
    color: theme.palette.text.primary,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  menuIcon: { fontSize: 24 },
  headerTitle: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center',
    flex: 1
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: 34,
    height: 34,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2.5, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5)
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.75)
  },
  sectionTitle: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75)
  },
  rowLabel: {
    ...theme.typography.body1,
    color: theme.palette.text.primary
  },
  checkbox: {
    padding: 0
  },
  footer: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white
  }
}))
